import React from 'react';
import PropTypes from 'prop-types';
import {
  Route,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { Spinner } from '@vibrent/electryon';
import * as style from '../components/logout/style.scss';
import ModuleRouteBound from './moduleRouteOutlet';

/**
 * FullView
 * @param {Object} props
 */
const FullView = props => (
  ((props.numberModuleWillBeLoad > 0) || props.getProgramDetails || props.requesting) ?
    <Spinner className={style['log-out-spinner-container']} /> :
    <Route exact={props.exact} path={props.path}>
      <ModuleRouteBound
        component={props.component}
        authenticated={props.authenticated}
        injectedProps={{
          userDetail: props.userDetail,
        }}
      />
    </Route>
);

const mapStateToProps = state => ({
  userDetail: state.UserDetail.get('userDetail'),
  roleSelected: state.UserDetail.get('roleSelected'),
  numberModuleWillBeLoad: state.ModuleLoader.get('numberModuleWillBeLoad'),
  getProgramDetails: state.LoginReducer.get('getProgramDetails'),
  requesting: state.ModuleLoader.get('requesting'),
});

export default connect(
  mapStateToProps,
  null,
)(FullView);

FullView.propTypes = {
  exact: PropTypes.bool,
  authenticated: PropTypes.bool,
  component: PropTypes.func.isRequired,
  path: PropTypes.string,
  userDetail: PropTypes.shape({}),
  numberModuleWillBeLoad: PropTypes.number,
  getProgramDetails: PropTypes.bool,
  requesting: PropTypes.bool,
};

FullView.defaultProps = {
  exact: false,
  authenticated: false,
  path: undefined,
  userDetail: undefined,
  roleSelected: undefined,
  numberModuleWillBeLoad: -1,
  getProgramDetails: false,
  requesting: false,
};
